const ActivateCustRecord = () =>
  import('@/views/main/inspect/activateCustRecord/ActivateCustRecord.vue')
export default {
  path: '/main/inspect/activateCustRecord',
  name: 'ActivateCustRecord',
  component: ActivateCustRecord
}
